/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Pos_To_ApproveInputs */

const en_queue_pos_to_approve = /** @type {(inputs: Queue_Pos_To_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase orders to approve`)
};

/**
* | output |
* | --- |
* | "Purchase orders to approve" |
*
* @param {Queue_Pos_To_ApproveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_pos_to_approve = /** @type {((inputs?: Queue_Pos_To_ApproveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Pos_To_ApproveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_pos_to_approve(inputs)
});